import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import * as fromEsign from './esign-reducer';
import { esignEffects } from './effects';
import { EnvironmentProviders } from '@angular/core';

export const provideEsignStore = (): EnvironmentProviders[] => [
    provideState(fromEsign.esignFeatureKey, fromEsign.reducer),
    provideEffects(esignEffects)
];
